module.exports = __webpack_public_path__ + "media/promo/advent/images/logo-5-a773004868d27901ebc4dc27f2717e45.png";